import React from 'react';
import styled from 'styled-components';

const StatusesWrapper = styled.div`
	display: inline-block;
`;

export const statuses = {
	'waiting': (
		<StatusesWrapper>
		<div>Очікує</div>
	</StatusesWrapper>
	),
	'sent': (
		<StatusesWrapper>
		<div>Розіслана</div>
		</StatusesWrapper>
	),
};



// WEBPACK FOOTER //
// ./src/operator/mailing/statuses.js